<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-card :header="$t('API Import')" style="position:relative">
          <b-form autocomplete="off" ref="aud">
            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="details.company_id ? details.company_id.value : ''"
                  label="Company"
                  :to="`/companies/${details.company_id.to}`"
                  type="link"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  :value="details.shop_id ? details.shop_id.value : ''"
                  label="Shop"
                  :to="`/shops/${details.shop_id.to}`"
                  type="link"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel :value="details.source" label="Source" type="plain" size="sm" />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel :value="details.date_from" label="Date From" type="plain" size="sm" />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel :value="details.date_to" label="Date To" type="plain" size="sm" />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel :value="details.timestamp" label="Timestamp" type="plain" size="sm" />
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <FloatingLabel :value="details.stake" label="Stake" type="plain" size="sm" />
              </b-col>
              <b-col>
                <FloatingLabel :value="details.payment" label="Payment" type="plain" size="sm" />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.payment_tax"
                  label="Payment Tax"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel :value="details.winnings" label="Winnings" type="plain" size="sm" />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.unclaimed_winnings"
                  label="Unclaimed Winnings"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.expired_winnings"
                  label="Expired Winnings"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <FloatingLabel
                  :value="details.expired_winnings_tax"
                  label="Expired Winnings Tax"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.paid_out_winnings"
                  label="Paid Out Winnings"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.cancelled_amount"
                  label="Cancelled Amount"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.cancelled_tax"
                  label="Cancelled Tax"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel :value="details.hold" label="Hold" type="plain" size="sm" />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.bonus_payout"
                  label="Bonus Payout"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <FloatingLabel
                  :value="details.bonus_payout_tax"
                  label="Bonus Payout Tax"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.ticket_balance_amount"
                  label="Ticket Balance Amount"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.ticket_paid_in_number"
                  label="Ticket Paid In Number"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.ticket_won_number"
                  label="Ticket Won Number"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.ticket_paid_out_number"
                  label="Ticket Paid Out Number"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.ticket_bonus_paid_out_number"
                  label="Ticket Bonus Paid Out Number"
                  type="plain"
                  size="sm"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <FloatingLabel
                  :value="details.ticket_cancelled_number"
                  label="Ticket Cancelled Number"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.ticket_expired_winnings_number"
                  label="Ticket Expired Winnings Number"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel
                  :value="details.payout_tax"
                  label="Payout Tax"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col>
                <FloatingLabel :value="details.payout" label="Payout" type="plain" size="sm" />
              </b-col>
            </b-row>
            <div style="text-align:right">
              <b-button type="button" variant="success" @click.prevent="reimport">{{$t('Reimport')}}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import { errorConf } from "@/shared/notifications";
import FloatingLabel from "@/components/FloatingLabel";

export default {
  name: "apiImport",
  props: ["selectedeid"],
  components: {
    FloatingLabel
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }
    Promise.all([
      this.$store.dispatch("cache/fetch", "companies").catch(e => e),
      this.$store.dispatch("cache/fetch", "shops").catch(e => e)
    ]).finally(() => {
      if (this.eid != "0" && this.eid != "") {
        this.loadData();
      } else {
        this.$router.push("/api-imports");
      }
    });
  },
  data: function() {
    return {
      eid: "",
      details: {
        product_id: "",
        shop_id: "",
        company_id: "",
        date_from: "",
        date_to: "",
        timestamp: "",
        stake: "",
        payment: "",
        payment_tax: "",
        winnings: "",
        unclaimed_winnings: "",
        expired_winnings: "",
        expired_winnings_tax: "",
        paid_out_winnings: "",
        cancelled_amount: "",
        cancelled_tax: "",
        hold: "",
        bonus_payout: "",
        bonus_payout_tax: "",
        ticket_balance_amount: "",
        ticket_paid_in_number: "",
        ticket_won_number: "",
        ticket_paid_out_number: "",
        ticket_bonus_paid_out_number: "",
        ticket_cancelled_number: "",
        ticket_expired_winnings_number: "",
        payout_tax: "",
        payout: "",
        source: ""
      },
      source: [
        "Manual",
        "NSoft Import",
        "Loto Import",
        "Newton Import",
        "WSix Import"
      ]
    };
  },
  methods: {
    loadData() {
      if (this.eid == "") return;

      const loadDet = this.$loading.open({
        container: this.$refs.aud
      });

      this.$store
        .dispatch("apiImports/read", this.eid)
        .then(resp => {
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.details.product_id = "";
      this.details.shop_id = "";
      this.details.company_id = "";
      this.details.date_from = this.mom_unix(r.date_from).format(
        "DD-MM-YY, HH:mm:ss"
      );
      this.details.date_to = this.mom_unix(r.date_to).format(
        "DD-MM-YY, HH:mm:ss"
      );
      this.details.timestamp = this.mom_unix(r.timestamp).format("DD-MM-YY");
      this.details.stake = this.roundThousands(r.stake);
      this.details.payment = this.roundThousands(r.payment);
      this.details.payment_tax = this.roundThousands(r.payment_tax);
      this.details.winnings = this.roundThousands(r.winnings);
      this.details.unclaimed_winnings = this.roundThousands(
        r.unclaimed_winnings
      );
      this.details.expired_winnings = this.roundThousands(r.expired_winnings);
      this.details.expired_winnings_tax = this.roundThousands(
        r.expired_winnings_tax
      );
      this.details.paid_out_winnings = this.roundThousands(r.paid_out_winnings);
      this.details.cancelled_amount = this.roundThousands(r.cancelled_amount);
      this.details.cancelled_tax = this.roundThousands(r.cancelled_tax);
      this.details.hold = this.roundThousands(r.hold);
      this.details.bonus_payout = this.roundThousands(r.bonus_payout);
      this.details.bonus_payout_tax = this.roundThousands(r.bonus_payout_tax);
      this.details.ticket_balance_amount = this.roundThousands(
        r.ticket_balance_amount
      );
      this.details.ticket_paid_in_number = r.ticket_paid_in_number;
      this.details.ticket_won_number = r.ticket_won_number;
      this.details.ticket_paid_out_number = r.ticket_paid_out_number;
      this.details.ticket_bonus_paid_out_number =
        r.ticket_bonus_paid_out_number;
      this.details.ticket_cancelled_number = r.ticket_cancelled_number;
      this.details.ticket_expired_winnings_number =
        r.ticket_expired_winnings_number;
      this.details.payout_tax = this.roundThousands(r.payout_tax);
      this.details.payout = this.roundThousands(r.payout);
      this.details.source = r.source ? this.source[r.source] : "";

      const companyByID = this.$store.getters["cache/companyByID"];
      const shopByID = this.$store.getters["cache/shopByID"];
      this.details.product_id = "";
      this.details.shop_id = "";
      this.details.company_id = "";

      if (r.eshop_id) {
        const data = shopByID(r.eshop_id);
        if (data) {
          this.details.shop_id = {
            value: data.name,
            to: r.eshop_id
          };
        } else {
          this.details.shop_id = {
            value: r.eshop_id,
            to: r.eshop_id
          };
        }
      }
      if (r.ecompany_id) {
        const data = companyByID(r.ecompany_id);
        if (data) {
          this.details.company_id = {
            value: data.name,
            to: r.ecompany_id
          };
        } else {
          this.details.company_id = {
            value: r.ecompany_id,
            to: r.ecompany_id
          };
        }
      }
    },
    reimport() {
      const loadDet = this.$loading.open({
        container: this.$refs.aud
      });

      const bulkData = {
        field: "reimport",
        value: true,
        ids: [this.eid]
      };

      this.$store.dispatch("apiImports/bulkAction", bulkData).finally(() => {
        loadDet.close();
      });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    roundThousands(value) {
      if (typeof value == "string") return value;
      if (!value) return "0.00";

      const decimals = 2;
      const tmp = value / 10000;

      return Number(Math.round(tmp + "e" + decimals) + "e-" + decimals).toFixed(
        decimals
      );
    },
    mom_unix(val) {
      return moment.unix(val / 1e9);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
